import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = not authenticated
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/auth/me`, { withCredentials: true });
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  }, [BACKEND_URL]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = useCallback(async (username, password) => {
    const { data } = await axios.post(`${BACKEND_URL}/api/auth/login`, { username, password }, { withCredentials: true });
    setUser(data);
    return data;
  }, [BACKEND_URL]);

  const logout = useCallback(async () => {
    await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, { withCredentials: true });
    setUser(false);
  }, [BACKEND_URL]);

  const value = useMemo(() => ({ user, login, logout }), [user, login, logout]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
